var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOeMdark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 932,
    viewBox: "0 0 1000 932",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_885_898",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1000,
    height: 932
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1000 0H0V931.19H1000V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_885_898)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1000 0H0V931.2H1000V0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M708.19 993.671L893.3 1100.44L1100.04 981.071L914.93 874.299L708.19 993.671Z",
    fill: "#9BB3D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M804.44 385.418V360.968L779.51 365.868L780.86 385.418H804.44Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M804.44 360.968L387.1 120.003L-431.82 592.823L-152.1 754.326L-213.28 789.657L383.62 1134.29L444.8 1098.96L572 1172.41H724.33L1390.92 787.537V699.585L1198.65 588.573C1178.17 600.403 1144.96 600.403 1124.48 588.573C1104 576.742 1104 557.572 1124.48 545.752L878.61 403.799C858.13 415.629 824.92 415.629 804.44 403.799C783.96 391.968 783.96 372.798 804.44 360.978V360.968Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.12 852.168L-42.95 887.998L-59.48 878.458L2.58002 842.618L19.12 852.168Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8202 866.428L-18.2398 902.268L-34.7798 892.718L27.2902 856.888L43.8202 866.428Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5302 880.699L6.47018 916.529L-10.0698 906.989L52.0002 871.149L68.5302 880.699Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2401 894.969L31.1801 930.799L14.6401 921.249L76.7101 885.419L93.2401 894.969Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.95 909.229L55.8801 945.069L39.3501 935.519L101.42 899.689L117.95 909.229Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 923.5L80.59 959.33L64.0601 949.79L126.13 913.95L142.66 923.5Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.37 937.76L105.3 973.6L88.77 964.05L150.83 928.22L167.37 937.76Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M688.55 1009.4L-232.39 477.68L-186.5 451.18L734.44 982.911L834.17 982.931L1198.2 772.757L1244.08 799.247L880.06 1009.42L688.55 1009.4Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1390.92 787.537V811.997L724.33 1196.87V1172.41L1390.92 787.537Z",
    fill: "#D7DCE0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M412.22 796.867L824.14 557.012V492.401L929.85 433.369",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5303 318.367L280.59 455.5V567.052L544.87 719.625",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8901 303.156L305.94 440.289V551.842L570.23 704.415",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8999 288.566L333.95 425.709V537.262L598.24 689.835",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M122.25 273.356L359.31 410.499V522.051L623.59 674.615",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.88 258.156L385.93 395.299V506.851L650.22 659.414",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M577.85 892.499L708.19 813.918H904.11L1245.54 615.123",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M266.2 765.716L117.95 850.778",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M290.91 779.977L142.66 865.049",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M315.62 794.247L167.37 879.309",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M499.03 899.949L350.77 985.021",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M291.561 369.467L295.941 374.727L298.331 373.337V345.707L291.561 349.617V369.467Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M289.17 370.857L295.94 374.727V347.097L289.17 351.007V370.857Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M298.33 345.707L287.87 351.747L281.09 347.887L291.56 341.837L298.33 345.707Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M287.87 351.747V354.517L281.09 350.647V347.887L287.87 351.747Z",
    fill: "#A6A6A6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M261.88 356.837V385.067L292.44 367.427V339.187L261.88 356.837Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M124.4 277.456L261.88 356.838L292.44 339.187L154.97 259.816L124.4 277.456Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M124.4 305.697V277.456L261.88 356.838V385.068L124.4 305.697Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M237.21 400.778V373.508L247.54 367.548L254.17 371.408L243.84 377.378V404.638L237.21 400.778Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M243.84 404.638V377.378L254.17 371.408V374.098L246.14 378.728V403.308L243.84 404.638Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M243.84 377.378L237.21 373.508V400.778L243.84 404.638V377.378Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M218.39 390.068L218.38 362.798L228.72 356.838L235.34 360.698L225.01 366.668V393.928L218.39 390.068Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M225.01 393.928V366.668L235.34 360.698V363.388L227.32 368.018V392.588L225.01 393.928Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M225.01 366.668L218.38 362.798L218.39 390.068L225.01 393.928V366.668Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M199.56 379.247V351.977L209.89 346.017L216.52 349.877L206.19 355.847V383.107L199.56 379.247Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M206.19 383.107V355.847L216.52 349.877V352.567L208.49 357.197V381.767L206.19 383.107Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M206.19 355.847L199.56 351.977V379.247L206.19 383.107V355.847Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M180.74 368.307V341.037L191.07 335.077L197.7 338.937L187.37 344.897V372.167L180.74 368.307Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M187.37 372.167V344.897L197.7 338.937V341.627L189.67 346.257V370.827L187.37 372.167Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M187.37 344.897L180.74 341.037V368.307L187.37 372.167V344.897Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M161.91 357.357V330.097L172.24 324.127L178.87 327.997L168.54 333.957V361.227L161.91 357.357Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M168.54 361.227V333.957L178.87 327.997V330.687L170.84 335.317V359.887L168.54 361.227Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M168.54 333.957L161.91 330.097V357.357L168.54 361.227V333.957Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M143.09 346.537V319.267L153.42 313.307L160.05 317.167L149.72 323.137V350.397L143.09 346.537Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M149.72 350.397V323.137L160.05 317.167V319.857L152.02 324.497V349.067L149.72 350.397Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M149.72 323.137L143.09 319.267V346.537L149.72 350.397V323.137Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M124.26 335.596V308.327L134.59 302.366L141.22 306.227L130.89 312.197V339.457L124.26 335.596Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M130.89 339.457V312.197L141.22 306.227V308.917L133.2 313.547V338.126L130.89 339.457Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M130.89 312.197L124.26 308.327V335.596L130.89 339.457V312.197Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M860.22 861.799C860.22 861.799 851.08 867.318 852.68 875.748C854.28 884.179 869.83 878.659 872.45 870.079C875.07 861.499 867.32 856.999 860.22 861.789V861.799Z",
    fill: "black"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M407.01 490.221V519.741L575.88 617.243H621.62L790.49 519.741V488.31L621.62 395.829H575.88L407.01 490.221Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M407.01 463.81V490.221L575.88 587.723H621.62L790.49 490.221V463.81L621.62 366.308H575.88L407.01 463.81Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M435.41 465.77V488.271L579.26 571.322H618.23L762.09 488.271V465.77L618.23 382.708H579.26L435.41 465.77Z",
    fill: "#070707",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M675.92 497.461L580.71 442.49L590.6 436.779L685.81 491.751L675.92 497.461Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M662.11 505.431L566.9 450.46L576.79 444.749L672 499.721L662.11 505.431Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M648.311 513.401L553.101 458.43L562.991 452.72L658.201 507.691L648.311 513.401Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M634.51 521.371L539.3 466.4L549.18 460.69L644.4 515.661L634.51 521.371Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M620.7 529.341L525.49 474.37L535.38 468.66L630.59 523.631L620.7 529.341Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M606.9 537.312L511.69 482.34L521.58 476.63L616.79 531.601L606.9 537.312Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M662.96 626.073L654.32 621.083L643.07 601.593L634.25 596.503L626.03 601.263L634.84 606.353L646.1 625.853L654.73 630.843L662.96 626.073Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M700.32 604.822L691.69 599.832L680.43 580.332L671.62 575.252L663.39 580.012L672.21 585.102L683.46 604.602L692.1 609.582L700.32 604.822Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M737.69 583.102L729.05 578.112L717.8 558.622L708.98 553.532L700.76 558.292L709.57 563.382L720.83 582.882L729.46 587.872L737.69 583.102Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M775.05 561.741L766.42 556.761L755.16 537.261L746.35 532.171L738.12 536.941L746.94 542.021L758.19 561.521L766.83 566.511L775.05 561.741Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M812.42 540.021L803.78 535.041L792.53 515.541L783.71 510.451L775.49 515.221L784.3 520.311L795.56 539.801L804.19 544.791L812.42 540.021Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M653.99 597.233L665.25 616.733L673.88 621.713L682.11 616.953V615.593L673.47 611.963L662.22 592.463L653.4 587.383L645.18 590.793V592.143",
    fill: "#7D7D7D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M682.11 615.593L673.47 610.613L662.22 591.113L653.4 586.023L645.18 590.793L653.99 595.873L665.25 615.373L673.88 620.363L682.11 615.593Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M719.471 593.872L710.841 588.892L699.581 569.392L690.771 564.302L682.541 569.072L691.361 574.162L702.611 593.652L711.25 598.642L719.471 593.872Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M756.84 572.522L748.2 567.532L736.95 548.032L728.13 542.942L719.91 547.712L728.72 552.802L739.98 572.302L748.61 577.282L756.84 572.522Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M794.2 550.801L785.57 545.811L774.31 526.311L765.5 521.231L757.27 525.991L766.09 531.081L777.34 550.581L785.98 555.561L794.2 550.801Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M534.09 626.073L542.72 621.083L553.98 601.593L562.79 596.503L571.02 601.263L562.21 606.353L550.95 625.853L542.31 630.843L534.09 626.073Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M496.72 604.822L505.36 599.832L516.62 580.332L525.43 575.252L533.65 580.012L524.84 585.102L513.58 604.602L504.95 609.582L496.72 604.822Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M459.36 583.102L467.99 578.112L479.25 558.622L488.06 553.532L496.29 558.292L487.48 563.382L476.22 582.882L467.58 587.872L459.36 583.102Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M421.99 561.741L430.63 556.761L441.89 537.261L450.7 532.171L458.92 536.941L450.11 542.021L438.85 561.521L430.22 566.511L421.99 561.741Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M384.63 540.021L393.26 535.041L404.52 515.541L413.33 510.451L421.56 515.221L412.75 520.311L401.49 539.801L392.85 544.791L384.63 540.021Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M514.94 615.593L523.57 610.613L534.83 591.113L543.64 586.023L551.87 590.793L543.06 595.873L531.8 615.373L523.16 620.363L514.94 615.593Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M477.57 593.872L486.21 588.892L497.47 569.392L506.28 564.302L514.5 569.072L505.69 574.162L494.43 593.652L485.8 598.642L477.57 593.872Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M440.21 572.522L448.84 567.532L460.1 548.032L468.91 542.942L477.14 547.712L468.33 552.802L457.07 572.302L448.43 577.282L440.21 572.522Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M402.84 550.801L411.48 545.811L422.74 526.311L431.55 521.231L439.77 525.991L430.96 531.081L419.7 550.581L411.07 555.561L402.84 550.801Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M433.17 928.35L425.39 923.85L415.44 929.59L407.81 925.19L400.55 929.4L408.18 933.8L418.13 928.06L425.91 932.56L433.17 928.35Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M472.28 905.859L464.5 901.369L454.55 907.109L446.92 902.699L439.66 906.919L447.29 911.319L457.24 905.579L465.02 910.069L472.28 905.859Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M490.14 895.189L482.35 890.699L472.4 896.439L464.78 892.029L457.52 896.239L465.14 900.649L475.09 894.909L482.88 899.399L490.14 895.189Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M508.64 884.609L500.85 880.109L490.91 885.849L483.28 881.449L476.02 885.659L483.65 890.069L493.59 884.319L501.38 888.819L508.64 884.609Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M451.75 917.42L443.97 912.93L434.02 918.67L426.39 914.27L419.13 918.48L426.76 922.88L436.71 917.14L444.49 921.63L451.75 917.42Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M565.97 948.62L409.47 1038.97V996.191L565.97 905.829V948.62Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M565.97 905.829L409.47 996.191L350.25 961.991L506.74 871.639L565.97 905.829Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M409.47 989.581L361.7 962.001L506.74 878.259L554.51 905.839L409.47 989.581ZM365.78 961.991L409.47 987.211L550.43 905.819L506.74 880.599L365.78 961.991Z",
    fill: "#FBB93E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M776.34 729.685V728.595L755.75 716.695L746.76 721.895L746.25 722.185L767.79 734.625L776.34 729.685Z",
    fill: "#7D7D7D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M754.8 716.165L746.25 721.095L767.79 733.535L776.34 728.595L754.8 716.165Z",
    fill: "#D1D1D1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M746.25 721.096V722.185L767.79 734.625V733.536L746.25 721.096Z",
    fill: "#BEBEBE"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M771.58 746.346L696.35 789.567V758.326L771.58 715.105V746.346Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M771.58 715.105L696.35 758.326L653.1 733.356L728.33 690.135L771.58 715.105Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M653.1 733.356V764.596L696.35 789.567V758.326L653.1 733.356Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M661.88 769.677L653.33 774.617L674.87 787.047L683.42 782.117L661.88 769.677Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M683.42 782.116L661.88 769.676V746.666L683.42 759.096V782.116Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M725.81 772.646L735.47 767.096V735.976L725.81 741.426V772.646Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M682.53 716.445L692.11 710.945L735.47 735.975L725.81 741.425L682.53 716.445Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M284.21 639.524V641.104L252.79 659.244V657.664L284.21 639.524Z",
    fill: "#BEBEBE"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M247.27 676.345L298.66 705.575V660.004L247.27 630.774V676.345Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M247.27 630.774L298.66 660.004L361.74 623.573L310.35 594.353L247.27 630.774Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M361.74 623.573V669.144L298.66 705.575V660.004L361.74 623.573Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M348.93 676.555L361.41 683.755L329.99 701.895L317.51 694.695L348.93 676.555Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M317.51 694.705L348.93 676.565V642.984L317.51 661.124V694.705Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M310.38 602.003L348.39 623.613L298.64 652.344L260.63 630.734L310.38 602.003ZM310.35 594.353L247.26 630.774L298.65 659.994L361.74 623.573L310.35 594.353Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M310.38 609.663L341.71 627.473L348.39 623.623L310.38 602.003L260.62 630.733L267.3 634.533L310.38 609.663Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M153.79 556.612C171.16 566.642 171.16 582.902 153.79 592.933C136.42 602.963 108.25 602.963 90.88 592.933C73.51 582.902 73.51 566.642 90.88 556.612C108.25 546.582 136.42 546.582 153.79 556.612Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8802 569.692C108.25 559.662 136.42 559.662 153.79 569.692C159.57 573.032 163.38 577.062 165.31 581.312C169.19 572.772 165.38 563.302 153.79 556.612C136.42 546.582 108.25 546.582 90.8802 556.612C79.2902 563.302 75.4702 572.772 79.3602 581.312C81.3002 577.052 85.1102 573.022 90.8802 569.692Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M447.9 707.135C463.79 716.305 463.79 731.176 447.9 740.356C432.01 749.526 406.25 749.526 390.37 740.356C374.48 731.186 374.48 716.315 390.37 707.135C406.26 697.965 432.01 697.965 447.9 707.135Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M378.45 723.745V690.575H459.81V723.745",
    fill: "#D7DCE0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M378.45 723.745V690.575H459.81V723.745",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M447.9 673.965C463.79 683.135 463.79 698.005 447.9 707.185C432.01 716.355 406.25 716.355 390.37 707.185C374.48 698.015 374.48 683.145 390.37 673.965C406.26 664.794 432.01 664.794 447.9 673.965Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M444.15 673.064C457.96 681.044 457.96 693.974 444.15 701.944C430.34 709.924 407.94 709.924 394.12 701.944C380.31 693.964 380.31 681.034 394.12 673.064C407.93 665.084 430.33 665.084 444.15 673.064Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M454.51 671.164H383.76V687.514H454.51V671.164Z",
    fill: "#434959"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M447.9 660.164C463.79 669.334 463.79 684.205 447.9 693.385C432.01 702.555 406.25 702.555 390.37 693.385C374.48 684.215 374.48 669.344 390.37 660.164C406.26 650.994 432.01 650.994 447.9 660.164Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M378.45 676.775V593.073H459.81V676.775",
    fill: "#D7DCE0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M378.45 676.775V593.073H459.81V676.775",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M447.9 576.472C463.79 585.643 463.79 600.513 447.9 609.693C432.01 618.863 406.25 618.863 390.37 609.693C374.48 600.523 374.48 585.653 390.37 576.472C406.26 567.302 432.01 567.302 447.9 576.472Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M440.99 580.452C453.06 587.422 453.06 598.722 440.99 605.692C428.92 612.662 409.34 612.662 397.27 605.692C385.2 598.722 385.2 587.422 397.27 580.452C409.34 573.482 428.92 573.482 440.99 580.452Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M397.27 589.542C409.34 582.572 428.92 582.572 440.99 589.542C445.01 591.862 447.65 594.662 449 597.622C451.7 591.682 449.05 585.112 440.99 580.452C428.92 573.482 409.34 573.482 397.27 580.452C389.21 585.102 386.56 591.682 389.26 597.622C390.6 594.662 393.25 591.862 397.27 589.542Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M434.31 180.174C467.38 199.264 467.38 230.225 434.31 249.315C401.24 268.406 347.63 268.406 314.56 249.315C281.49 230.225 281.49 199.264 314.56 180.174C347.63 161.083 401.24 161.083 434.31 180.174Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M289.76 214.745V145.703H459.11V214.745",
    fill: "#D7DCE0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M289.76 214.745V145.703H459.11V214.745",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M434.31 111.132C467.38 130.223 467.38 161.183 434.31 180.274C401.24 199.364 347.63 199.364 314.56 180.274C281.49 161.183 281.49 130.223 314.56 111.132C347.63 92.042 401.24 92.042 434.31 111.132Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 115.642C455.25 132.243 455.25 159.163 426.5 175.764C397.75 192.364 351.13 192.364 322.37 175.764C293.62 159.163 293.62 132.243 322.37 115.642C351.12 99.042 397.74 99.042 426.5 115.642Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M322.37 131.803C351.12 115.202 397.74 115.202 426.5 131.803C437.3 138.043 444.04 145.733 446.73 153.783C451.2 140.393 444.46 126.013 426.5 115.642C397.75 99.0421 351.13 99.0421 322.37 115.642C304.42 126.013 297.68 140.393 302.14 153.783C304.83 145.733 311.57 138.043 322.37 131.803Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M434.31 209.405C401.24 228.495 347.63 228.495 314.56 209.405C298.03 199.854 289.76 187.344 289.76 174.834V194.994C289.76 207.505 298.03 220.015 314.56 229.565C347.63 248.655 401.24 248.655 434.31 229.565C450.84 220.015 459.11 207.505 459.11 194.994V174.834C459.11 187.344 450.84 199.854 434.31 209.405Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M124.64 371.148C115.75 366.018 104.12 363.188 91.8902 363.188C79.6602 363.188 68.0301 366.018 59.1401 371.148L-68.2399 444.69C-78.4899 450.61 -84.3599 459.34 -84.3599 468.64C-84.3599 477.94 -78.4799 486.67 -68.2399 492.591C-59.3499 497.721 -47.7199 500.551 -35.4899 500.551C-23.2599 500.551 -11.6299 497.721 -2.73987 492.591L124.64 419.049C134.89 413.129 140.76 404.399 140.76 395.099C140.76 385.798 134.88 377.058 124.64 371.148Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M124.64 352.578C115.75 347.448 104.12 344.617 91.8902 344.617C79.6602 344.617 68.0301 347.448 59.1401 352.578L-68.2399 426.119C-78.4899 432.039 -84.3599 440.77 -84.3599 450.07C-84.3599 459.37 -78.4799 468.1 -68.2399 474.02C-59.3499 479.15 -47.7199 481.98 -35.4899 481.98C-23.2599 481.98 -11.6299 479.15 -2.73987 474.02L124.64 400.479C134.89 394.559 140.76 385.828 140.76 376.528C140.76 367.228 134.88 358.488 124.64 352.578Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M131.67 373.628H131.7V232.355L-75.5301 310.187V449.12C-75.5701 449.76 -75.5701 450.39 -75.5301 451.03V451.45H-75.5001C-74.9401 456.9 -71.0901 462.28 -63.8601 466.46C-48.1901 475.51 -22.7801 475.51 -7.11008 466.46L120.27 392.918C129.39 387.658 133.16 380.488 131.67 373.628Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5099 218.875L-63.8701 292.416C-79.5401 301.467 -79.5401 316.137 -63.8701 325.187C-48.2001 334.237 -22.7901 334.237 -7.12006 325.187L120.26 251.645C135.93 242.595 135.93 227.925 120.26 218.875C104.59 209.825 79.1799 209.825 63.5099 218.875Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3501 506.12V505.06L16.6201 502.24L7.84006 487.04L0.970062 483.07L-5.43994 485.73V486.79L1.43005 490.75L10.2 505.95L16.9401 509.84L23.3501 506.12Z",
    fill: "#7D7D7D"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3501 505.06L16.6201 501.18L7.84006 485.98L0.970062 482.01L-5.43994 485.73L1.43005 489.7L10.2 504.89L16.9401 508.78L23.3501 505.06Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4699 489.56V488.5L45.7399 485.67L36.9699 470.47L30.0999 466.51L23.6899 469.16V470.22L30.5599 474.19L39.3299 489.39L46.0599 493.27L52.4699 489.56Z",
    fill: "#7D7D7D"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4699 488.5L45.7399 484.61L36.9699 469.41L30.0999 465.45L23.6899 469.16L30.5599 473.13L39.3299 488.33L46.0599 492.21L52.4699 488.5Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 472.63V471.57L74.8701 468.74L66.0901 453.54L59.2201 449.58L52.8101 452.23V453.29L59.6801 457.26L68.4601 472.46L75.1901 476.34L81.6 472.63Z",
    fill: "#7D7D7D"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 471.57L74.8701 467.68L66.0901 452.48L59.2201 448.52L52.8101 452.23L59.6801 456.2L68.4601 471.4L75.1901 475.28L81.6 471.57Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M110.73 455.979V454.919L104 452.089L95.2199 436.889L88.3499 432.929L81.9399 435.589V436.639L88.8099 440.609L97.58 455.809L104.32 459.689L110.73 455.979Z",
    fill: "#7D7D7D"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M110.73 454.919L104 451.039L95.2199 435.839L88.3499 431.869L81.9399 435.589L88.8099 439.549L97.58 454.749L104.32 458.639L110.73 454.919Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M139.85 439.049V437.989L133.12 435.159L124.35 419.959L117.48 415.999L111.07 418.649V419.709L117.94 423.679L126.71 438.879L133.44 442.759L139.85 439.049Z",
    fill: "#7D7D7D"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M139.85 437.989L133.12 434.109L124.35 418.909L117.48 414.939L111.07 418.649L117.94 422.619L126.71 437.819L133.44 441.709L139.85 437.989Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M126.71 437.819L133.12 434.109L139.85 437.989L133.44 441.709L126.71 437.819Z",
    fill: "#BEBEBE"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2802 497.96V496.9L31.5402 494.07L22.7702 478.87L15.9002 474.9L9.49023 477.56V478.62L16.3602 482.59L25.1302 497.78L31.8602 501.67L38.2802 497.96Z",
    fill: "#7D7D7D"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2802 496.9L31.5402 493.01L22.7702 477.81L15.9002 473.85L9.49023 477.56L16.3602 481.53L25.1302 496.73L31.8602 500.61L38.2802 496.9Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4004 481.03V479.97L60.6703 477.14L51.9004 461.94L45.0304 457.97L38.6104 460.63V461.69L45.4803 465.66L54.2603 480.85L60.9904 484.74L67.4004 481.03Z",
    fill: "#7D7D7D"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4004 479.97L60.6703 476.08L51.9004 460.88L45.0304 456.92L38.6104 460.63L45.4803 464.6L54.2603 479.8L60.9904 483.68L67.4004 479.97Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5302 464.379V463.319L89.8002 460.49L81.0203 445.289L74.1502 441.329L67.7402 443.979V445.039L74.6102 449.009L83.3802 464.21L90.1202 468.089L96.5302 464.379Z",
    fill: "#7D7D7D"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5302 463.319L89.8002 459.43L81.0203 444.229L74.1502 440.27L67.7402 443.979L74.6102 447.949L83.3802 463.15L90.1202 467.029L96.5302 463.319Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M125.65 447.449V446.389L118.92 443.559L110.15 428.359L103.28 424.399L96.8701 427.049V428.109L103.74 432.079L112.51 447.279L119.24 451.159L125.65 447.449Z",
    fill: "#7D7D7D"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M125.65 446.389L118.92 442.499L110.15 427.299L103.28 423.339L96.8701 427.049L103.74 431.019L112.51 446.219L119.24 450.099L125.65 446.389Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M131.69 354.098V346.727C130.65 351.698 126.86 356.508 120.26 360.318L-7.12006 433.859C-22.7901 442.91 -48.2001 442.91 -63.8701 433.859C-71.2801 429.579 -75.1501 424.039 -75.5501 418.429V429.599C-75.5901 430.239 -75.5901 430.869 -75.5501 431.509V431.929H-75.5201C-74.9601 437.379 -71.1101 442.76 -63.8801 446.94C-48.2101 455.99 -22.8001 455.99 -7.13007 446.94L120.25 373.398C129.37 368.138 133.14 360.968 131.65 354.108H131.68L131.69 354.098Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M505.78 773.116C504.43 773.116 503.34 772.026 503.34 770.676V753.566C503.34 750.486 504.55 748.026 506.67 746.806C508.78 745.586 511.52 745.766 514.19 747.306L516.43 748.596C517.6 749.266 518 750.766 517.32 751.936C516.65 753.106 515.15 753.506 513.98 752.826L511.74 751.536C510.64 750.906 509.66 750.716 509.11 751.036C508.56 751.356 508.23 752.296 508.23 753.566V770.676C508.23 772.026 507.13 773.116 505.79 773.116H505.78Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M532.4 740.736C532.3 740.676 532.19 740.616 532.09 740.556L531.93 740.466C529.8 739.426 526.95 739.656 523.82 741.466C517.23 745.266 511.89 754.526 511.89 762.136C511.89 766.057 513.31 768.757 515.58 769.957L561.38 796.417L578.28 767.247L532.41 740.736H532.4Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M582.16 775.176C582.16 782.786 576.82 792.036 570.23 795.846C563.64 799.646 558.3 796.566 558.3 788.956C558.3 781.346 563.64 772.096 570.23 768.286C576.82 764.476 582.16 767.566 582.16 775.176Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M533.94 780.586C532.7 779.106 531.96 776.906 531.96 774.086C531.96 766.316 537.41 756.866 544.14 752.986C546.69 751.516 549.05 751.076 551 751.496L547.14 749.266C547.04 749.206 546.93 749.146 546.83 749.086L546.67 748.996C544.54 747.956 541.7 748.186 538.56 749.996C531.97 753.806 526.63 763.056 526.63 770.666C526.63 774.586 528.05 777.286 530.32 778.486L533.94 780.586Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M582.16 817.467C580.81 817.467 579.72 816.377 579.72 815.027V797.667C579.72 793.937 576.99 789.217 573.76 787.347L569.01 784.607C567.84 783.937 567.44 782.437 568.12 781.267C568.79 780.097 570.29 779.697 571.46 780.377L576.21 783.117C580.92 785.837 584.61 792.227 584.61 797.667V815.027C584.61 816.377 583.52 817.467 582.17 817.467H582.16Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M970.16 745.205C971.51 745.205 972.6 744.115 972.6 742.765V725.655C972.6 722.575 971.39 720.115 969.27 718.895C967.16 717.675 964.42 717.855 961.75 719.395L959.51 720.685C958.34 721.355 957.94 722.855 958.62 724.025C959.29 725.195 960.79 725.595 961.96 724.915L964.2 723.625C965.3 722.995 966.28 722.805 966.83 723.125C967.38 723.445 967.71 724.385 967.71 725.655V742.765C967.71 744.115 968.81 745.205 970.15 745.205H970.16Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M943.54 712.825C943.64 712.765 943.75 712.705 943.85 712.645L944.01 712.555C946.14 711.515 948.98 711.745 952.12 713.555C958.71 717.355 964.05 726.616 964.05 734.226C964.05 738.146 962.63 740.846 960.36 742.046L914.56 768.507L897.66 739.336L943.53 712.825H943.54Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M893.78 747.266C893.78 754.876 899.12 764.126 905.71 767.936C912.3 771.736 917.64 768.656 917.64 761.046C917.64 753.436 912.3 744.186 905.71 740.376C899.12 736.576 893.78 739.656 893.78 747.266Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M942 752.675C943.24 751.195 943.98 748.995 943.98 746.175C943.98 738.405 938.53 728.955 931.8 725.075C929.25 723.605 926.89 723.165 924.94 723.585L928.8 721.355C928.9 721.295 929.01 721.235 929.11 721.175L929.27 721.085C931.4 720.045 934.25 720.275 937.38 722.085C943.97 725.885 949.31 735.145 949.31 742.755C949.31 746.675 947.89 749.375 945.62 750.575L942 752.675Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M893.78 789.556C895.13 789.556 896.22 788.466 896.22 787.116V769.756C896.22 766.026 898.95 761.306 902.18 759.436L906.93 756.696C908.1 756.026 908.5 754.526 907.82 753.356C907.15 752.186 905.65 751.786 904.48 752.466L899.73 755.206C895.02 757.926 891.33 764.316 891.33 769.756V787.116C891.33 788.466 892.42 789.556 893.77 789.556H893.78Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M943.91 482.2C945.26 482.2 946.35 481.11 946.35 479.76V462.65C946.35 459.57 945.14 457.11 943.02 455.89C940.91 454.67 938.17 454.85 935.5 456.39L933.26 457.68C932.09 458.35 931.69 459.85 932.37 461.02C933.04 462.19 934.54 462.59 935.71 461.91L937.95 460.62C939.05 459.99 940.03 459.8 940.58 460.12C941.13 460.44 941.46 461.38 941.46 462.65V479.76C941.46 481.11 942.56 482.2 943.9 482.2H943.91Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M917.28 449.81C917.38 449.75 917.49 449.69 917.59 449.63L917.75 449.54C919.88 448.5 922.72 448.73 925.86 450.54C932.45 454.34 937.79 463.6 937.79 471.21C937.79 475.13 936.37 477.83 934.1 479.03L888.3 505.491L871.4 476.32L917.27 449.81H917.28Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M867.52 484.26C867.52 491.87 872.86 501.12 879.45 504.93C886.04 508.73 891.38 505.65 891.38 498.04C891.38 490.43 886.04 481.18 879.45 477.37C872.86 473.57 867.52 476.65 867.52 484.26Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M915.74 489.67C916.98 488.19 917.72 485.99 917.72 483.17C917.72 475.4 912.27 465.95 905.54 462.07C902.99 460.6 900.63 460.16 898.68 460.58L902.54 458.35C902.64 458.29 902.75 458.23 902.85 458.17L903.01 458.08C905.14 457.04 907.99 457.27 911.12 459.08C917.71 462.88 923.05 472.14 923.05 479.75C923.05 483.67 921.63 486.37 919.36 487.57L915.74 489.67Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M867.53 526.541C868.88 526.541 869.97 525.451 869.97 524.101V506.741C869.97 503.011 872.7 498.291 875.93 496.421L880.68 493.681C881.85 493.011 882.25 491.511 881.57 490.341C880.9 489.171 879.4 488.771 878.23 489.451L873.48 492.191C868.77 494.911 865.08 501.301 865.08 506.741V524.101C865.08 525.451 866.17 526.541 867.52 526.541H867.53Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M172.13 517.041C170.78 517.041 169.69 515.951 169.69 514.601V497.491C169.69 494.411 170.9 491.951 173.02 490.731C175.13 489.511 177.87 489.691 180.54 491.231L182.78 492.521C183.95 493.191 184.35 494.691 183.67 495.861C183 497.031 181.5 497.431 180.33 496.751L178.09 495.461C176.99 494.831 176.01 494.641 175.46 494.961C174.91 495.281 174.58 496.221 174.58 497.491V514.601C174.58 515.951 173.48 517.041 172.14 517.041H172.13Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M198.76 484.66C198.66 484.6 198.55 484.54 198.45 484.48L198.29 484.39C196.16 483.35 193.32 483.58 190.18 485.39C183.59 489.191 178.25 498.451 178.25 506.061C178.25 509.981 179.67 512.681 181.94 513.881L227.74 540.342L244.64 511.171L198.77 484.66H198.76Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M248.51 519.101C248.51 526.711 243.17 535.961 236.58 539.771C229.99 543.581 224.65 540.491 224.65 532.881C224.65 525.271 229.99 516.021 236.58 512.211C243.17 508.401 248.51 511.491 248.51 519.101Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M200.3 524.521C199.06 523.041 198.32 520.841 198.32 518.021C198.32 510.251 203.77 500.801 210.5 496.921C213.05 495.451 215.41 495.011 217.36 495.431L213.5 493.201C213.4 493.141 213.29 493.081 213.19 493.021L213.03 492.931C210.9 491.891 208.06 492.121 204.92 493.931C198.33 497.731 192.99 506.991 192.99 514.601C192.99 518.521 194.41 521.221 196.68 522.421L200.3 524.521Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M248.51 561.391C247.16 561.391 246.07 560.301 246.07 558.951V541.591C246.07 537.861 243.34 533.141 240.11 531.271L235.36 528.531C234.19 527.861 233.79 526.361 234.47 525.191C235.14 524.021 236.64 523.621 237.81 524.301L242.56 527.041C247.27 529.761 250.96 536.151 250.96 541.591V558.951C250.96 560.301 249.87 561.391 248.52 561.391H248.51Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M459.12 800.237C457.77 800.237 456.67 799.137 456.67 797.787V780.607C456.67 777.517 457.89 775.047 460.01 773.817C462.13 772.597 464.88 772.777 467.56 774.317L469.8 775.617C470.97 776.297 471.37 777.797 470.7 778.967C470.02 780.137 468.52 780.547 467.35 779.867L465.11 778.567C464.01 777.937 463.02 777.747 462.47 778.067C461.92 778.387 461.59 779.337 461.59 780.607V797.787C461.59 799.137 460.49 800.237 459.14 800.237H459.12Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M485.85 767.727C485.75 767.667 485.64 767.607 485.54 767.547L485.38 767.456C483.24 766.406 480.39 766.646 477.24 768.467C470.62 772.287 465.26 781.577 465.26 789.217C465.26 793.147 466.69 795.867 468.97 797.067L514.96 823.638L531.93 794.347L485.87 767.727H485.85Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M535.81 802.307C535.81 809.947 530.45 819.237 523.83 823.057C517.21 826.877 511.85 823.777 511.85 816.137C511.85 808.497 517.21 799.207 523.83 795.387C530.45 791.567 535.81 794.667 535.81 802.307Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M487.4 807.746C486.15 806.256 485.41 804.056 485.41 801.216C485.41 793.416 490.89 783.926 497.64 780.026C500.2 778.546 502.57 778.106 504.53 778.536L500.66 776.296C500.56 776.236 500.45 776.176 500.35 776.116L500.19 776.026C498.05 774.976 495.2 775.216 492.05 777.036C485.43 780.856 480.07 790.146 480.07 797.786C480.07 801.716 481.5 804.436 483.78 805.636L487.42 807.746H487.4Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M535.81 844.767C534.46 844.767 533.36 843.667 533.36 842.317V824.887C533.36 821.147 530.62 816.397 527.38 814.527L522.61 811.777C521.44 811.097 521.04 809.597 521.71 808.427C522.39 807.247 523.89 806.847 525.06 807.527L529.83 810.277C534.56 813.007 538.26 819.427 538.26 824.887V842.317C538.26 843.667 537.16 844.767 535.81 844.767Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M970.18 525.841L1033.56 562.442V489.25L970.18 452.65V525.841Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M970.18 452.65L983.18 445.31L1046.57 481.91L1033.56 489.25L970.18 452.65Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M970.18 492.651L1033.56 529.241V514.781L970.18 478.18V492.651Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M926.4 549.592L989.79 586.182V512.991L926.4 476.4V549.592Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M989.79 586.183L1002.79 578.842V505.651L989.79 512.991V586.183Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M926.4 476.4L939.41 469.06L1002.79 505.65L989.79 512.99L926.4 476.4Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M926.4 516.401L989.79 552.992V538.532L926.4 501.931V516.401Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M989.79 552.991L1002.79 545.651V531.181L989.79 538.531V552.991Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M261.84 848.968L198.24 885.689V812.237L261.84 775.527V848.968Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M198.24 885.689L185.19 878.319V804.877L198.24 812.237V885.689Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M261.84 775.527L248.79 768.157L185.19 804.877L198.24 812.237L261.84 775.527Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M222.82 759.256C223.13 759.786 223.35 760.436 223.35 761.296C223.35 764.206 221.31 767.736 218.79 769.196C217.99 769.656 217.27 769.766 216.61 769.726C217.36 771.006 218.86 771.346 220.64 770.326C223.16 768.876 225.2 765.336 225.2 762.426C225.2 760.446 224.22 759.356 222.82 759.266V759.256Z",
    fill: "#4B4D54"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M236.14 743.036L199.59 764.136L186.79 784.037V803.957L248.79 768.167L248.88 748.196L236.14 743.046V743.036ZM220.64 770.237C218.16 771.667 216.15 770.507 216.15 767.647C216.15 764.786 218.16 761.306 220.64 759.876C223.12 758.446 225.13 759.606 225.13 762.466C225.13 765.326 223.12 768.807 220.64 770.237Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M261.84 815.658L198.24 852.378V837.858L261.84 801.137V815.658Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M198.24 852.378L185.19 845.008V830.498L198.24 837.858V852.378Z",
    fill: "#FBB93E",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOeMdark);
export default __webpack_public_path__ + "static/media/OEMdark.ab417878e9cd8abf1aa0d6755eeda912.svg";
export { ForwardRef as ReactComponent };